import { getSettingsFromAuthRequest } from '@/utils-v2/helpers/auth/generateSettingsRequest';
import { getParamsRequest } from '@/utils-v2/helpers/auth/generateParamsRequest';
import { grantTypeDictionary } from '@/entities/enums/GrantTypes';
import axios from 'axios';
import { setCookie } from '@/utils-v2/libs/cookieWrapper';
import { authClientProxy } from '@/api/modules/auth/client';

const url = '/api/v2/oauth2/tokens';
const chocoUrl = `${import.meta.env.VITE_BASE_URL}${import.meta.env.VITE_GATEWAY_API_PREFIX}/v0/common/choco/login`;

export const getTokenByCode = async code => {
  const params = getParamsRequest(grantTypeDictionary.code, { code });
  const settings = getSettingsFromAuthRequest();
  const { access_token } = await authClientProxy().post(url, params, settings);

  return axios.post(chocoUrl, {
    access_token: access_token,
  }).then((data)=> {
    setCookie('auth_token', data.data.tokens.access_token);
  });
};
